module.exports = __webpack_public_path__ + "static/fibrenetwork-134655650336da2903f0cb29e5e0b2a4.svg";